import Big from 'big.js'
import { useContext } from 'react'

import FiatCounter from '../FiatCounter'

import { CryptoInputContext } from './CryptoInputGroup'

function UsdValue({ prefix = '' }) {
  const { selectedToken, inputValue } = useContext(CryptoInputContext)
  const usdRate = selectedToken?.usdPrice || 1
  return (
    <FiatCounter end={Big(usdRate).times(inputValue || 0)} prefix={prefix} />
  )
}

export default UsdValue
